module.exports = __webpack_public_path__ + "51de5b560203c9a2aea01d9d4dc843cb.svg";